export default (function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelContext, ActionMessageUtil) {
    var translateFn = TranslateService.instant;

    function wrappedLoadSave(action, model) {
        var promise = action.call(undefined, model);
        return promise.then(function (submissionDTO) {
            return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelContext);
        });
    }

    var QUOTE_STEP_NAME = 'quoteDetails';

    var ACTION_MSG = {
        cancelPrompt: {
            noSaveRequired: 'quoteandbind.common.config.FlowConfig.The information you have entered will not be saved',
            saveDraft: 'quoteandbind.common.config.FlowConfig.The information previously entered will be stored as a draft quote submission',
            saveOffering: 'quoteandbind.common.config.FlowConfig.The information previously entered will be stored as a quote submission'
        },
        checkAvailability: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to request a quote',
                message: 'quoteandbind.common.config.FlowConfig.Sorry we are unable to quote for this location and start date.'
            },
            progress: {
                title: 'quoteandbind.common.config.FlowConfig.Checking product availability',
                message: 'quoteandbind.common.config.FlowConfig.Checking if a quote can be provided for that location'
            }
        },
        checkPeriodStartDateChanged: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to request a quote',
                message: 'quoteandbind.common.config.FlowConfig.Sorry coverage is not available for the effective date specified.'
            },
            progress: {
                title: 'quoteandbind.common.config.FlowConfig.Checking product availability',
                message: 'quoteandbind.common.config.FlowConfig.Checking if coverage is available for that date.'
            }
        },
        createSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to create submission',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to create the quote submission.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Saving details...'
            }
        },
        saveSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Saving quote...'
            }
        },
        saveAndQuoteSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to generate a quote',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to calculate a quote.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Calculating Quote...'
            }
        },
        bindSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to purchase quote',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to bind your quote submission'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Processing Payment...'
            }
        },
        retrievePaymentPlans: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to retrieve payment plans',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to retrieve payment plans.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Retrieving payment plans...'
            }
        }
    };
    var ACTIONS = {
        checkAvailability: function checkAvailability(model, availabilityRequest) {
            // wrap the availablity check promise in a promise that returns the model with the policy address set
            return new $q(function (resolve, reject) {
                var availabilityPromise = AvailabilityService.checkAvailabilityBasedOnPostalCode(availabilityRequest);
                availabilityPromise.then(function (availabilityResp) {
                    if (!availabilityResp.isAvailable) {
                        reject();
                    }
                    // Set the policy address using the availability response if no address has been set yet
                    if (!angular.isDefined(model.baseData.policyAddress.value)) {
                        model.baseData.policyAddress.value = availabilityResp.addressCompletion;
                    }
                    resolve(model);
                }, function (error) {
                    reject(error);
                });
            });
        },
        cancel: function cancel(model, args) {
            if (!model.quoteID.value) {
                // no submission was created so just exit without saving
                return $q.resolve(model);
            }
            if (args.visitedSteps.includes(QUOTE_STEP_NAME)) {
                return LoadSaveService.saveQuotedSubmission(model.value);
            }
            return LoadSaveService.saveSubmission(model.value);
        },
        createSubmission: function createSubmission(_ref) {
            var submission = _ref.value;
            return wrappedLoadSave(LoadSaveService.createSubmission, submission);
        },
        saveDraftSubmission: function saveDraftSubmission(_ref2) {
            var submission = _ref2.value;
            return wrappedLoadSave(LoadSaveService.saveSubmission, submission);
        },
        saveQuotedSubmission: function saveQuotedSubmission(_ref3) {
            var submission = _ref3.value;
            return wrappedLoadSave(LoadSaveService.saveQuotedSubmission, submission);
        },
        saveAndQuoteSubmission: function saveAndQuoteSubmission(_ref4) {
            var submission = _ref4.value;
            return wrappedLoadSave(LoadSaveService.saveAndQuoteSubmission, submission);
        },
        bindSubmission: function bindSubmission(_ref5) {
            var submission = _ref5.value;
            return wrappedLoadSave(LoadSaveService.bindSubmission, submission);
        },
        retrievePaymentPlans: function retrievePaymentPlans(_ref6) {
            var submission = _ref6.value;
            return LoadSaveService.retrievePaymentPlans(submission).then(function (paymentPlanDTOs) {
                submission.bindData.paymentPlans = paymentPlanDTOs;
                return ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelContext);
            });
        }
    };

    return {
        globalExits: function globalExits(step, junction) {
            junction('error');

            junction('returnHome');

            junction('cancel').data({
                confirmationMsg: function confirmationMsg(model) {
                    if (!model.quoteID.value) {
                        return ACTION_MSG.cancelPrompt.noSaveRequired;
                    }
                    if (!model.quoteData.value) {
                        return ACTION_MSG.cancelPrompt.saveDraft;
                    }
                    return ACTION_MSG.cancelPrompt.saveOffering;
                }
            }).onNext.doAction(ACTIONS.cancel, ACTION_MSG.saveSubmission).thenGoTo('returnHome', 'error');
        },
        availabilityCheck: function availabilityCheck(step, junction) {
            junction('checkAvailability', true).onNext.doAction(ACTIONS.checkAvailability, ACTION_MSG.checkAvailability).thenGoTo('productAvailable', 'error');

            junction('productAvailable');
        },
        needToSaveCheck: function needToSaveCheck(step, junction) {
            junction('checkNewSubmissionOrIfPeriodStartDateHasChanged', true).onNext.branch(function (model, args) {
                if (!model.quoteID.value) {
                    return 'newSubmission';
                }
                if (args.periodStartDateChanged) {
                    return 'periodStartDateChanged';
                }
                return 'needToSaveCheckSuccess';
            });

            junction('newSubmission').onNext.doAction(ACTIONS.createSubmission, ACTION_MSG.createSubmission).thenGoTo('needToSaveCheckSuccess', 'error');

            junction('periodStartDateChanged').onNext.doAction(ACTIONS.checkAvailability, ACTION_MSG.checkPeriodStartDateChanged).thenGoTo('needToSaveCheckSuccess', 'error');

            junction('needToSaveCheckSuccess');
        },
        quote: function quote(step, junction) {
            junction('generateQuote', true).onNext.doAction(ACTIONS.saveAndQuoteSubmission, ActionMessageUtil.quoteFailMessage).thenGoTo('quoteDetails', 'error');

            step('quoteDetails').onNext.goTo('offeringSelected', 'error').skipOnResumeIf(function (model) {
                return model.bindData.policyNumber && model.bindData.policyNumber.value;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Quote');
            });

            junction('offeringSelected');
        },
        bindAndPay: function bindAndPay(step, junction) {
            junction('moreInfoComplete', true).onNext.doAction(ACTIONS.retrievePaymentPlans, ACTION_MSG.retrievePaymentPlans).thenGoTo('paymentDetails', 'error');

            step('paymentDetails').onNext.doAction(ACTIONS.bindSubmission, ACTION_MSG.bindSubmission).thenGoTo('confirmation', 'error').skipOnResumeIf(function (model) {
                return model.bindData.policyNumber && model.bindData.policyNumber.value;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Payment Details');
            });

            junction('confirmation');
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/common/config/FlowConfig.js
// module id = 392
// module chunks = 0